<template>
    <div id="mobile-offers" class="container-fluid">
        <div class="row px-1">
            <div class="col-12 px-0">
                <h2 class="h3 mb-md-2 mb-1" v-html="mobileOffersData.titleHtml" />
            </div>
            <div class="col-12 px-0">
                <!--/* CAROUSEL EN MODE MOBILE */-->
                <div class="container mw-100 mb-1">
                    <div class="row px-0">
                        <div class="col-12 px-0">
                            <swiper-container
                                uniq-swiper-id="mobileOffersSwiper1"
                                :slides-per-view="swiperSlidesPerView"
                                :space-between="swiperSpaceBetween"
                                :pagination="swiperPagination"
                                :navigation="swiperNavigation"
                                :update-navigation-position-in-screen="swiperUpdateNavigationPositionInScreen"
                                :breakpoints="swiperBreakpoints"
                            >
                                <swiper-slide
                                    v-for="offer in offersTilesWithUpdatedFoLink"
                                    :key="JSON.stringify(offer)"
                                    :is-initial-swiper-slide="offer.seoId === selectedMobileOfferSeoId"
                                >
                                    <MobileOfferTile
                                        :offer="offer"
                                        :selected-mobile-offer-seo-id="selectedMobileOfferSeoId"
                                        @select-offer="selectOffer"
                                    />
                                </swiper-slide>
                                <swiper-slide v-if="mobileOffersData.edito5gTile" class="swiper-slide-height">
                                    <MobileEditoTile
                                        v-if="mobileOffersData.edito5gTile"
                                        v-once
                                        :title-html="mobileOffersData.edito5gTile.titleHtml"
                                        :show-picto5-g="mobileOffersData.edito5gTile.showPicto5G"
                                        :picto5g-src="mobileOffersData.edito5gTile.picto5gSrc"
                                        :attributes="mobileOffersData.edito5gTile.attributes"
                                        :link-label="mobileOffersData.edito5gTile.linkLabel"
                                        :link="mobileOffersData.edito5gTile.link"
                                        :link-tms="mobileOffersData.edito5gTile.linkTms"
                                    />
                                </swiper-slide>
                            </swiper-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MobileOfferTile from "./MobileOfferTile";
import MobileEditoTile from "./MobileEditoTile.vue";
import {alignDivHeights} from "../../../../utils/AlignDivHeightsUtil";
import SwiperContainer from "../../../../../../common/components/vue/swiper/SwiperContainer.vue";
import SwiperSlide from "../../../../../../common/components/vue/swiper/SwiperSlide.vue";

export default {
    name: "MobileOffers",
    components: {
        MobileOfferTile,
        MobileEditoTile,
        SwiperContainer,
        SwiperSlide
    },
    props: {
        mobileOffersData: {type: Object, required: true},
        mobileOffersModel: {type: Array, required: true},
        selectedMobileOfferSeoId: {type: String, required: true},
        foLinkQueryParams: {type: Object, required: false, default: undefined},
    },
    data() {
        return {
            swiperSlidesPerView: 1.15,
            swiperPagination: false,
            swiperSpaceBetween: 30,
            swiperNavigation: true,
            swiperUpdateNavigationPositionInScreen: true,
            swiperBreakpoints: {
                // when window width is >= 560px
                560: {
                    slidesPerView: 1.6
                },
                // when window width is >= 736px
                736: {
                    slidesPerView: 2.5
                },
                // when window width is >= 1050px
                1050: {
                    slidesPerView: 3.2
                },
                // when window width is >= 1280px
                1280: {
                    slidesPerView: 3.5
                }
            }
        }
    },
    computed: {
        offersSelection: function () {
            return this.filterOffers(this.mobileOffersModel);
        },
        offersTiles: function () {
            return this.extractOffersTiles(this.offersSelection, this.mobileOffersData.mobileOffersTiles);
        },
        offersTilesWithUpdatedFoLink() {
            if (this.foLinkQueryParams) {
                return this.offersTiles.map((offerTile) => {
                    const updatedFoLink = new URL(offerTile.foLink);

                    updatedFoLink.searchParams.set('offreInternet', this.foLinkQueryParams.offreInternet);
                    updatedFoLink.searchParams.set('offreMobile', this.foLinkQueryParams.offreMobile);
                    updatedFoLink.searchParams.set('vitrineHashTag', this.foLinkQueryParams.vitrineHashTag);
                    // without queryParam technology update

                    return { ...offerTile, foLink: updatedFoLink.toString() }
                })
            }
            return this.offersTiles
        },
    },
    updated() {
        const listOfDivToAlign = [
            "mobile-attributes", "mobile-claim", "mobile-promo", "mobile-ob1-price", "mobile-open-discount", "mobile-selection"];
        alignDivHeights(listOfDivToAlign);
    },
    methods: {
        selectOffer(offerSeoId) {
            this.$emit('select-mobile-offer-seo-id', offerSeoId);
        },
        filterOffers: function (mobileOffersModel) {
            return mobileOffersModel
                    .filter(offer => offer.displayTile === true)
                    .map(offer => offer.seoId)
        },
        extractOffersTiles(offersSelection, mobileOffersTiles) {
            return mobileOffersTiles.filter(offer => offersSelection.includes(offer.seoId));
        }
    }

}
</script>

<style scoped lang="scss">

// hack hauteur tuiles noires EDITO
.swiper-slide-height {
    height: auto !important;
}

</style>
